/**
 * Módulo 13 na tela — o aviso explicado (0039). A regra, o período e os
 * números que acionaram vêm do servidor; aqui só se escreve cada um do jeito
 * que o manual manda: vírgula decimal, ponto de milhar e unidade separada.
 */
import { formatarData, formatarDataHora } from '@/lib/formato';

export interface DadoDoAviso {
  readonly rotulo: string;
  readonly valor: unknown;
  readonly unidade: string;
}

/** O número em português e a unidade ao lado; o que não é número passa como veio. */
export function textoDoDado(d: DadoDoAviso): string {
  if (d.valor === null || d.valor === undefined || d.valor === '') return 'sem valor';
  const n = typeof d.valor === 'number' ? d.valor : typeof d.valor === 'string' ? Number(d.valor) : Number.NaN;
  const texto = Number.isFinite(n)
    ? n.toLocaleString('pt-BR', { maximumFractionDigits: 3 })
    : typeof d.valor === 'string'
      ? d.valor
      : JSON.stringify(d.valor);
  return d.unidade ? `${texto} ${d.unidade}` : texto;
}

/**
 * O período que a regra olhou. Um instante só vira "em ..."; sem início (a
 * preventiva que nunca foi feita) vira "até ...".
 */
export function textoDoPeriodo(de: string | null, ate: string | null): string | null {
  if (de === null && ate === null) return null;
  if (de !== null && (ate === null || ate === de)) return `em ${formatarDataHora(new Date(de))}`;
  if (de === null && ate !== null) return `até ${formatarDataHora(new Date(ate))}`;
  const inicio = new Date(de ?? '');
  const fim = new Date(ate ?? '');
  const mesmoDia = formatarData(inicio) === formatarData(fim);
  return mesmoDia
    ? `em ${formatarData(inicio)}, das ${formatarDataHora(inicio).slice(-5)} às ${formatarDataHora(fim).slice(-5)}`
    : `de ${formatarData(inicio)} a ${formatarData(fim)}`;
}
